import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/expense-ratio-calculator',
  component: () => import('../../routes/ExpenseRatioCalculator.svelte'),
  card: {
    id: 'expense-ratio-calculator',
    title: 'Expense Ratio Calculator',
    description: 'See how much expense ratios cost you over time and compare funds with different fee structures.',
    icon: 'receipt_long',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/expense-ratio-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Expense Ratio Calculator – Mutual Fund & ETF Fee Impact',
    description: 'Free expense ratio calculator. See how mutual fund and ETF fees compound over time and cost you thousands in lost growth.',
  },
};

export default meta;